import {
	getController,
	type HpRequestOptional,
	apiService as Service,
} from '@/services/service'

const url = 'tasks'

export const taskService = {
	...getController<Api.Task, Api.TaskPostInput, Api.TaskUpdateInput>(url),
	show: (id: number, data?: HpRequestOptional) =>
		Service.get({
			url: `${url}/${id}?rel=["units", "persons", "buildings", "records", "craftsman_tasks", "team_created", "team_assigned", "documents.document_files"]`,
			...data,
		}),

	binary: (id: number, document_id: number, data?: HpRequestOptional) =>
		Service.get({
			url: `${url}/${id}/documents/${document_id}/binary`,
			...data,
		}),
}

export default taskService
